export const STATE_INITIAL = 'initial'
export const STATE_REQUESTING = 'requesting'
export const STATE_SUCCESS = 'success'
export const STATE_FAILURE = 'failure'
